import Alpine from "alpinejs";

Alpine.store('popups', {
    init() {
        let i = {};

        document.querySelectorAll('.popup').forEach(function (item){
            i[item.id] = false;
        });

        this.items = i;

        window.addEventListener('scroll', () => {
            this.y = window.pageYOffset;
        });
    },

    items: null,

    active: null,

    activeElement: null,

    y: 0,

    show(event) {
        let active = typeof event == 'string' ? event : (event.currentTarget.getAttribute('href') || event.currentTarget.dataset.popup)
            .replace('#', '');

        this.items[active] = true;
        this.active = active;
        this.activeElement = document.getElementById(active);

        window.setTimeout(() => {
            this.activeElement
                .querySelector('.popup-window')
                .classList
                .add('popup-window--active')
        }, 50)

        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.y}px`;
    },

    close(event) {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);

        this.activeElement
            .querySelector('.popup-window')
            .classList
            .remove('popup-window--active')

        this.items[this.active] = false;
        this.active = null;

    },
    closeAll() {
        for (let item in this.items) {
            this.items[item] = false;
        }
    }
})
